/**
* DevExpress Dashboard (_gauge-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { parseBool } from '../../../metadata/_base-metadata';
import { kpiDashboardItemSerializationsInfo } from '../../kpi/metadata/_kpi-item';
export let gauges = { propertyName: 'gauges', modelName: 'Gauges', displayName: 'DashboardStringId.DefaultNameGaugeItem', array: true };
export let gaugeViewType = {
    propertyName: 'viewType', modelName: '@ViewType', displayName: 'DashboardWebStringId.Gauge.Type', defaultVal: 'CircularFull', valuesArray: [
        { value: 'CircularFull', displayValue: 'DashboardWebStringId.Gauge.Type.FullQuarterGauge' },
        { value: 'CircularHalf', displayValue: 'DashboardWebStringId.Gauge.Type.HalfCircular' },
        { value: 'CircularQuarterLeft', displayValue: 'DashboardWebStringId.Gauge.Type.LeftQuarterCircular' },
        { value: 'CircularQuarterRight', displayValue: 'DashboardWebStringId.Gauge.Type.RightQuarterCircular' },
        { value: 'CircularThreeFourth', displayValue: 'DashboardWebStringId.Gauge.Type.ThreeFourthCircular' },
        { value: 'LinearHorizontal', displayValue: 'DashboardWebStringId.Gauge.Type.LinearHorizontal' },
        { value: 'LinearVertical', displayValue: 'DashboardWebStringId.Gauge.Type.LinearVertical' }
    ]
};
export let showGaugeCaptions = { propertyName: 'showGaugeCaptions', modelName: '@ShowGaugeCaptions', displayName: 'DashboardWebStringId.Gauge.Captions', defaultVal: true, simpleFormAdapterItem: 'onOffButtonGroupEditor', from: parseBool };
export let gaugeDashboardItemSerializationsInfo = kpiDashboardItemSerializationsInfo.concat([gauges, gaugeViewType, showGaugeCaptions]);
